import React, { useContext } from 'react';
import { observer } from 'mobx-react-lite';
import { Link } from 'react-router-dom';
import EmailOutlinedIcon from '@mui/icons-material/EmailOutlined';
import PhoneOutlinedIcon from '@mui/icons-material/PhoneOutlined';
import BadgeOutlinedIcon from '@mui/icons-material/BadgeOutlined';
import BusinessOutlinedIcon from '@mui/icons-material/BusinessOutlined';
import { Context } from '../index';
import '../styles/StorefrontPages.css';

const ROLE_LABEL = { 1: 'Администратор', 2: 'Оператор', 3: 'Пользователь' };

const ProfilePage = observer(() => {
  const { user } = useContext(Context);
  const profile = user?.profile || {};
  const loginName = user?.user?.login || '—';
  const fullName = [profile.lastname, profile.firstname, profile.secondname]
    .filter(Boolean).join(' ') || loginName;
  const initials = (fullName.match(/\S+/g) || [])
    .slice(0, 2).map(s => s[0]?.toUpperCase()).join('') || 'U';
  const role = ROLE_LABEL[Number(user?.role)] || '—';
  const activeClient = user?.activeClient;

  return (
    <div className="sfpage">
      <div className="sfpage__head">
        <span className="sfpage__eyebrow">Профиль</span>
        <h1 className="sfpage__title">Мой аккаунт</h1>
        <p className="sfpage__lead">Краткая информация о вашей учётной записи и роли в системе.</p>
      </div>

      <div className="sfprofile__hero">
        <div className="sfprofile__avatar">{initials}</div>
        <div className="sfprofile__head">
          <h2 className="sfprofile__name">{fullName}</h2>
          <span className="sfprofile__login">@{loginName}</span>
          <div className="sfprofile__chips">
            <span className="sfchip">{role}</span>
            {activeClient && <span className="sfchip sfchip--brand">{activeClient.name || `Клиент #${activeClient.id_clients}`}</span>}
          </div>
        </div>
        <Link to="/settings" className="sfpage__cta-btn sfpage__cta-btn--ghost">Редактировать</Link>
      </div>

      <div className="sfpage__grid sfpage__grid--2">
        <div className="sfcard">
          <div className="sfcard__icon"><EmailOutlinedIcon /></div>
          <div className="sfcard__body">
            <span className="sfcard__label">Email</span>
            <span className="sfcard__primary">{profile.email || '—'}</span>
            <span className="sfcard__secondary">Для уведомлений и восстановления доступа</span>
          </div>
        </div>
        <div className="sfcard">
          <div className="sfcard__icon"><PhoneOutlinedIcon /></div>
          <div className="sfcard__body">
            <span className="sfcard__label">Телефон</span>
            <span className="sfcard__primary">{profile.phone || profile.phone_number || '—'}</span>
            <span className="sfcard__secondary">Контакт менеджера</span>
          </div>
        </div>
        <div className="sfcard">
          <div className="sfcard__icon"><BadgeOutlinedIcon /></div>
          <div className="sfcard__body">
            <span className="sfcard__label">Роль</span>
            <span className="sfcard__primary">{role}</span>
            <span className="sfcard__secondary">Уровень доступа</span>
          </div>
        </div>
        <div className="sfcard">
          <div className="sfcard__icon"><BusinessOutlinedIcon /></div>
          <div className="sfcard__body">
            <span className="sfcard__label">Активный клиент</span>
            <span className="sfcard__primary">{activeClient ? (activeClient.name || `#${activeClient.id_clients}`) : '—'}</span>
            <span className="sfcard__secondary">Переключается в боковой панели CRM</span>
          </div>
        </div>
      </div>
    </div>
  );
});

export default ProfilePage;
